import client from './client';
import { getAccessToken } from './localstorage';

export async function decodeBase64Blob(blob, contentType) {
  try {
    const base64String = (await blob.text()).replace(/\s/g, '');
    const byteArray = Uint8Array.from(atob(base64String), char => char.charCodeAt(0));
    return new Blob([byteArray], { type: contentType });
  } catch (err) {
    console.warn('Failed to decode waste invoice blob, using original content', err);
    return blob;
  }
}

export async function downloadWasteInvoice({ customerDomainId, invoiceNumber, documentFormat = 'pdf' }) {
  const bearerToken = getAccessToken();
  if (!bearerToken) throw new Error('no_access_token');

  const endpoint = `/api/multiutility/waste/download/${customerDomainId}/invoices/${invoiceNumber}?documentFormat=${documentFormat}`;
  const resp = await client.get(endpoint, {
    headers: { Authorization: bearerToken },
    responseType: 'blob',
  });

  const disposition = resp.headers['content-disposition'] || '';
  const filenameStarMatch = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const rawName = filenameStarMatch?.[1] || filenameMatch?.[1] || `${invoiceNumber}.${documentFormat}`;
  const filename = decodeURIComponent(rawName);
  const contentType = resp.headers['content-type'] || 'application/octet-stream';
  const blob = await decodeBase64Blob(resp.data, contentType);

  return { blob, contentType, filename };
}
